import { Link } from 'react-router-dom';

export function HeaderLogo() {
  return (
    <Link to="/">
      <img
        src="/assets/gti/logo-primary-dark.svg"
        alt="GTI"
        height="100%"
        style={{ height: '40px' }}
      />
    </Link>
  );
}
